import React, { useState } from "react";
import CustomHeading from "../components/CustomHeading";
import Plan16Marla from "../assets/Images/16Marla.png";
import Plan5Marla from "../assets/Images/5Marla.png";
import Plan5marla2 from "../assets/Images/5Marla2.jpeg";
import Plan5MarlaVideo from "../assets/Videos/5marlaPlan.mp4";
import Plan3 from "../assets/Images/3Plan.png";
import ImageWithHoverEffect from "../components/ImageWithHoverEffect";
import VideoWithHoverEffect from "../components/VideoWithHoverEffect";
import ArrowLabel from "../components/ArrowLabel";
import PlanModal from "../components/PlanModal";
import Marla5IMG1 from "../assets/Images/5Marla-IMG1.jpg";
import Marla5IMG2 from "../assets/Images/5Marla-IMG2.jpg";
import Marla5IMG3 from "../assets/Images/5Marla-IMG3.jpg";
import Marla5IMG4 from "../assets/Images/5Marla-IMG4.jpg";
import Marla5IMG5 from "../assets/Images/5Marla-IMG5.jpg";
import Marla5IMG6 from "../assets/Images/5Marla-IMG6.jpg";
import Marla5IMG7 from "../assets/Images/5Marla-IMG7.jpg";
import Marla5IMG8 from "../assets/Images/5Marla-IMG8.jpg";
import Marla5IMG9 from "../assets/Images/5Marla-IMG9.jpg";
import Marla5IMG10 from "../assets/Images/5Marla-IMG10.jpg";
import Marla5IMG11 from "../assets/Images/5Marla-IMG11.jpg";
import Marla5IMG12 from "../assets/Images/5Marla-IMG12.jpg";
import Marla5IMG13 from "../assets/Images/5Marla-IMG13.jpg";
import Marla5IMG14 from "../assets/Images/5Marla-IMG14.jpg";

const plansData = [
  {
    id: 1,
    planName: "4.16 MARLA",
    medias: [
      {
        type: "image",
        url: Plan3,
        thumbnailUrl: Plan3,
        caption: "3 Marla Overview",
      },
      {
        type: "video",
        url: Plan5MarlaVideo,
        thumbnailUrl: Plan5marla2,
        caption: "3D Walkthrough Video",
      },
    ],
    plans: [
      {
        category: "Bronze",
        standardPrice: "15,500,000",
        booking: "2,500,000",
        allocation: "2,500,000",
        installments: "222,222",
        possession: "2,500,000",
      },
      {
        category: "Gold",
        standardPrice: "16,000,000",
        booking: "2,600,000",
        allocation: "2,600,000",
        installments: "227,777",
        possession: "2,600,000",
      },
      {
        category: "Platinum",
        standardPrice: "16,500,000",
        booking: "2,700,000",
        allocation: "2,700,000",
        installments: "233,333",
        possession: "2,700,000",
      },
    ],
    description: [
      "Design your Home",
      "Choose your own floor plan",
      "Stay updated with the process of construction on the web portal",
      "List of all the vendors supplying materials will be available on the web portal",
    ],
    overlayTitle: "4.16 Marla",
    overlaySubTitle: "Ground Floor Plan for 4.16 Marla house.",
  },
  {
    id: 2,
    planName: "5 MARLA",
    medias: [
      {
        type: "image",
        url: Marla5IMG2,
        thumbnailUrl: Marla5IMG2,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG1,
        thumbnailUrl: Marla5IMG1,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Plan5Marla,
        thumbnailUrl: Plan5Marla,
        caption: "5 Marla Overview",
      },
      {
        type: "image",
        url: Marla5IMG3,
        thumbnailUrl: Marla5IMG3,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG4,
        thumbnailUrl: Marla5IMG4,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG5,
        thumbnailUrl: Marla5IMG5,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG6,
        thumbnailUrl: Marla5IMG6,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG7,
        thumbnailUrl: Marla5IMG7,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG8,
        thumbnailUrl: Marla5IMG8,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG9,
        thumbnailUrl: Marla5IMG9,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG10,
        thumbnailUrl: Marla5IMG10,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG11,
        thumbnailUrl: Marla5IMG11,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG12,
        thumbnailUrl: Marla5IMG12,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG13,
        thumbnailUrl: Marla5IMG13,
        caption: "5 Marla Elevation",
      },
      {
        type: "image",
        url: Marla5IMG14,
        thumbnailUrl: Marla5IMG14,
        caption: "5 Marla Elevation",
      },
    ],
    planTitles: {
      category: "Category",
      standardPrice: "Standard Price",
      booking: "Down Payment",
      allocation: "Confirmation Payment",
      installments: "Installments (24 months)",
      possession: "Possession",
    },
    plans: [
      {
        category: "Platinum",
        standardPrice: "18,500,000",
        booking: "3,700,000",
        allocation: "1,500,000",
        installments: "284,375",
        possession: "3,700,000",
      },
    ],
    description: [
      "Design your Home",
      "Choose your own floor plan",
      "Stay updated with the process of construction on the web portal",
      "List of all the vendors supplying materials will be available on the web portal",
    ],
    overlayTitle: "5 Marla",
    overlaySubTitle: "Ground Floor and First Floor Plan for 5 Marla house.",
  },
  {
    id: 3,
    planName: "10 MARLA",
    medias: [
      {
        type: "image",
        url: Plan16Marla,
        thumbnailUrl: Plan16Marla,
        caption: "10 Marla Structure",
      },
    ],
    plans: [
      {
        category: "Platinum",
        standardPrice: "37,000,000 PKR",
        booking: "5,000,000 PKR",
        allocation: "5,000,000 PKR",
        installments: "527,778 PKR",
        possession: "5,000,000 PKR",
      },
    ],
    description: [
      "Design your Home",
      "Choose your own floor plan",
      "Stay updated with the process of construction on the web portal",
      "List of all the vendors supplying materials will be available on the web portal",
    ],
    overlayTitle: "10 Marla Villa",
    overlaySubTitle:
      "Ground Floor, First Floor, and Mumty Plan for 10 Marla house.",
  },
];

const HousingPlan = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openModal = (plan) => {
    setModalData(plan);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const renderPlanMedia = (plan) => {
    // Determine which media to show in the preview
    // By default, show the first media. For video priority, check if there's a video
    const mainMedia =
      plan.medias.find((media) => media.type === "video") || plan.medias[0];

    if (mainMedia.type === "video") {
      return (
        <VideoWithHoverEffect
          videoSrc={mainMedia.url}
          overlayTitle={plan.overlayTitle}
          overlaySubTitle={plan.overlaySubTitle}
          onClick={() => openModal(plan)}
        />
      );
    } else {
      return (
        <ImageWithHoverEffect
          image={mainMedia.url}
          overlayTitle={plan.overlayTitle}
          overlaySubTitle={plan.overlaySubTitle}
          onClick={() => openModal(plan)}
        />
      );
    }
  };

  return (
    <div className="container mx-auto bg-gray-50">
      <CustomHeading
        heading={"Plan"}
        description="Nothing can get in the way of honesty. In the real estate market, many have come and gone. What still stands today and will stand forever is honesty"
      />

      <section className="p-4 sm:p-6">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8 font-heading">
          Plans We Offer
        </h2>

        {plansData.map((plan, index) => (
          <section
            key={plan.id}
            className="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0 p-4"
          >
            {/* Description section - always on the left side */}
            <div className="w-full md:w-1/2 flex flex-col items-start text-left justify-center">
              <ul className="mb-3">
                {plan.description.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <ArrowLabel
                label={plan.planName}
                color="black"
                onClick={() => openModal(plan)}
              />
            </div>

            {/* Media section - always on the right side */}
            <div className="w-full md:w-1/2">{renderPlanMedia(plan)}</div>
          </section>
        ))}
      </section>

      {/* Modal */}
      {isModalOpen && modalData && (
        <PlanModal
          medias={modalData.medias}
          planName={modalData.planName}
          pricingData={modalData.plans}
          onClose={closeModal}
          planTitles={modalData.planTitles}
        />
      )}
    </div>
  );
};

export default HousingPlan;
